// Tool imports - simplified for wps_pages (template-only use)
import WYSIWYG from '../tools/WYSIWYG';
import { Debug } from './utils/Debug';

// Tool modules registry - only WYSIWYG
const toolModules = {
    WYSIWYG  // Rich text / template editor
};

/**
 * Get default tool configuration
 * @returns {Object} Default tool configuration
 */
export function getDefaultToolConfig() {
    const tools = {};

    for (const [toolName, ToolClass] of Object.entries(toolModules)) {
        const toolbox = ToolClass.toolbox ? ToolClass.toolbox() : {};

        tools[toolName] = {
            class: ToolClass,
            config: toolbox.config || {},
            // Optional metadata for toolbar display
            category: toolbox.category || 'Basic',
            icon: toolbox.icon,
            allowRawPreview: toolbox.allowRawPreview !== false
        };
    }

    return tools;
}

/**
 * Get editor configuration from DOM or default
 * @returns {Object} Editor configuration with tools
 */
export function getEditorConfigFromDOM() {
    // For wps_pages, we just use the default config (WYSIWYG only)
    return {
        tools: getDefaultToolConfig()
    };
}
